import { render, staticRenderFns } from "./first-login.vue?vue&type=template&id=1b9d934e&scoped=true&"
import script from "./first-login.vue?vue&type=script&lang=js&"
export * from "./first-login.vue?vue&type=script&lang=js&"
import style0 from "./first-login.vue?vue&type=style&index=0&id=1b9d934e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9d934e",
  null
  
)

export default component.exports